export enum ErrorLevel {
  Debug,
  Info,
  Warn,
  Error,
}
